<template name="createNewScript">
  <div>
    <div class="content">
      <div class="info-card">
        <div style="display: flex;justify-content: center;align-items: center" class="info-content">
          <span class="user-info-content">脚本名称：</span>
          <el-input v-model="scriptName" autocomplete="off"></el-input>
        </div>
      </div>

      <div class="info-card">
        <div style="display: flex;justify-content: center;align-items: center" class="info-content">
          <span class="user-info-content">项目描述：</span>
          <el-input v-model="description" autocomplete="off"></el-input>
        </div>
      </div>

      <div class="info-card">
        <div style="display: flex;justify-content: center;align-items: center" class="info-content">
          <span class="user-info-content">选择变量：</span>
          <el-select v-model="updateVariableId" placeholder="请选择变量">
            <el-option
                v-for="item in options"
                :key="item.id"
                :label="item.variableName"
                :value="item.id">
            </el-option>
          </el-select>
        </div>
      </div>
      <div class="button-group-card">
        <div class="button-group-title">
          <el-button type="success" @click="commit" :plain="true">确认创建</el-button>
        </div>
      </div>
    </div>
    <el-dialog title="确认创建脚本？" :visible.sync="commitDialogVisible">
      <div slot="footer" class="dialog-footer">
        <el-button @click="commitDialogVisible=false">取 消</el-button>
        <el-button type="primary" @click="handleCommit">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import API from "@/../config/api.js";
import IMGURL from "@/../config/imgUrl.js";

export default {
  name: "createNewScript",
  data() {
    return {
      scriptName: '',
      description: '',
      updateVariableId: '', //变量选择
      options: [],         //选择框的选择内容
      variableName: '',      //选中的变量的名字

      userId: '',
      logoProduct: IMGURL.logoProduct, //logo图片
      logoCheck: IMGURL.logoCheck, //logo图片
      logoLaunch: IMGURL.logoLaunch, //logo图片
      customStyle: {
        color: '#3399ff',
      },
      customStyle2: {
        color: '#ffaa00',
      },
      customStyle3: {
        color: '#55aa00',
      },
      customStyle4: {
        color: '#aa55ff',
      },
      productId: '',  //新建的脚本的Id
      commitDialogVisible: false, //提交脚本 对话框
    }
  },
  props: {
    companyId: Number,
  },

  mounted() {
    this.userId = window.localStorage.getItem('userid');
    this.getVariableList();
  },

  methods: {
    //获取变量列表
    getVariableList() {
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }

      let data = {
        companyId: this.companyId,
      }
      console.log(data)
      this.$axiosRequest({
        url: API.getVariableList,
        method: 'POST',
        data: data,
        header: header,
        success: res => {
          console.log(res.data)
          this.options = res.data["variableList"]

        }
      });
    },
    handleCommit(){
      let header = {
        "Content-Type": "application/x-www-form-urlencoded"
      }
      for (let i = 0; i < this.options.length; i++) {
        if (this.options[i].id == this.updateVariableId)
          this.variableName = this.options[i].variableName
      }
      let newScript = {
        companyId: this.companyId,
        scriptName: this.scriptName,
        description: this.description,
        updateVariableId: this.updateVariableId,
        scriptSource: '[' + this.variableName + '] = '
      }

      this.$axiosRequest({
        url: API.addScript,
        method: 'POST',
        data: newScript,
        header: header,
        success: res => {
          if (res.data > 0) {
            this.$message({
              message: '创建脚本成功',
              type: 'success'
            });
            this.commitDialogVisible = false;
            //后期根据接口重新修改，要打开
            let newChild = { //后期删掉
              label: this.scriptName,
              stageType: 5,
              id: res.data,
              updateVariableId: this.updateVariableId,
              uniqueId: 'Script_' + res.data,
              children: []
            }

            console.log('eeeeeeeee', res.data)
            this.$emit('add', newChild);
          } else if (res.data == 0) {
            this.$message({
              message: '脚本名称重复',
              type: 'warning'
            });
            return;
          } else if (res.data == -2) {
            this.$message({
              message: '参数出错',
              type: 'warning'
            });
            return;
          } else if (res.data == -1) {
            this.$message({
              message: '保存出错',
              type: 'warning'
            });
            return;
          }
        }
      });
    },
    //确认创建脚本
    commit() {
      if (this.scriptName != '' && this.description != '' && this.updateVariableId != '') {
        this.commitDialogVisible = true;
      } else if(this.scriptName == ''){
        this.$message({
          message: "脚本名称不能为空！",
          type: 'warning'
        });
      }else if(this.description == ''){
        this.$message({
          message: "脚本描述不能为空！",
          type: 'warning'
        });
      }else if(this.updateVariableId == ''){
        this.$message({
          message: "变量不能为空！",
          type: 'warning'
        });
      }
    },
  }

}
</script>

<style lang="less">
.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  // background-color:rgba(240,240,240,0.5);
  padding: 12px;
}

.row-line {
  line-height: 20px;
}

.info-title {
  font-size: 18px;
  font-weight: bold;
  color: #004768;
  font-family: '仿宋';
}

.info-content {
  font-size: 18px;
  font-family: '仿宋';
  // font-weight: bold;
}

.button-group-title {
  font-size: 18px;
  font-weight: bold;
}

.info-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  padding: 12px;
  background-color: rgba(240, 240, 240, 0.7);
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  line-height: 40px;
}

.title3-style {
  font-size: 14px;
  line-height: 40px;
}

.btn {
  margin-left: 80px;

}

.user-info-content {
  font-weight: bold;
}

.info-content {
  margin: 10px 0px 10px 10px; // 上 右 下 左
  height: auto;
}

.title-style {
  font-size: 18px;
  font-weight: bold;
}

.title2-style {
  font-size: 15px;
  font-weight: bold;
  line-height: 40px;
}

.button-group-card {
  margin: 10px 15px 10px 15px; // 上 右 下 左
  // background-color:rgba(240,240,240,0.5);
  padding: 12px;
}
</style>
